import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { withRouter } from "react-router";

import Diagram from "./../Diagram";
import AuthenticatedRoute from "../Login/AuthenticatedRoute";
import Header from "./Header";
import Footer from "./Footer";
import Sample from "./../Sample";
import Main from "./../Main";
/* new main */
import NewMain from "../NewMain";

import Login from "../Login/Login";
import Signup from "./../Signup";
import FindAccount from "./../FindAccount";
import Logout from "./../Logout";

// import ProjectMain from "../../pages/Project/Main";
import ProjectMain from "../Project/ProjectMain";
import ProjectMap from "../Project/ProjectMap";
import ProjectCreate from "../Project/ProjectCreate";
import ProjectEdit from "../Project/ProjectEdit";

import EmsMain from "../../pages/Ems/Main";

// import PlantStatusMain from "../../pages/PlantStatus/Main";
import PlantStatusIssueDetailV2 from "../../pages/PlantStatus/Issue/DetailV2";
import PlantStatusIssueDetail from "../../pages/PlantStatus/Issue/Detail";
import PlantStatusCombiner from "../../pages/PlantStatus/Issue/Combiner";
import PlantStausIssueHistory from "../../pages/PlantStatus/Issue/History";
import PlantStausIssueHistoryDetail from "../../pages/PlantStatus/Issue/HistoryDetail";

import PlantListMain from "../PlantList/Main";
import PlantListCreate from "../../pages/PlantList/Create";
import PlantListDetail from "../../pages/PlantList/Detail/Main";
import PlantListDrawing from "../../pages/PlantList/DrawingModule";
import PlantListDrawingV2 from "../../pages/PlantList/DrawingModuleV2";
import PlantListUpdate from "../../pages/PlantList/Update";
import PlantEquip from "../../pages/PlantList/Equip";
import SolarPanelCreate from "../../pages/PlantList/Solar/Create";
import SolarPanelDetail from "../PlantList/Solar/Detail";
import SolarPanelEdit from "../PlantList/Solar/Edit";
import PowerDeviceCreate from "../../pages/PlantList/Power/Create";
import PowerDeviceDetail from "../../pages/PlantList/Power/Detail";
import PowerCarrierDetail from "../../pages/PlantList/Power/DetailCarrier";
import PowerDeviceEdit from "../../pages/PlantList/Power/Edit";

import PlantDetailInverter from "../../pages/PlantList/Detail/Inverter/Index";
import PlantDetailInverterStat from "../../pages/PlantList/Detail/Inverter/Stat";
import Mypage from "../../pages/MyPage/Main";
import Inquiry from "../../pages/Inquiry/Main";

import Flow from "../../pages/Analysis/Flow";
import BatteryCreate from "../PlantList/battery/Create";
import BatteryEdit from "../PlantList/battery/Edit";
import BatteryDetail from "../PlantList/battery/Detail";
import BatteryGraph from "../PlantList/battery/graph/index";
import ProjectTitle from "./ProjectTitle";
import EmsMainNew from "../Ems/MainNew";
import SiteManagerMain   from "../SiteManager/SiteManagerMain";
import SiteManagerCreate from "../SiteManager/SiteManagerCreate";
import SiteManagerEdit   from "../SiteManager/SiteManagerEdit";
import MemberMain        from "../Member/MemberMain";
import MemberCreate      from "../Member/MemberCreate";
import MemberEdit        from "../Member/MemberEdit";
import InquiryMain       from "../CS/Inquiry/InquiryMain";
import InquiryDetail     from "../CS/Inquiry/InquiryDetail";
import NoticeMain        from "../CS/Notice/NoticeMain";
import NoticeCreate      from "../CS/Notice/NoticeCreate";
import NoticeDetail      from "../CS/Notice/NoticeDetail";
import FirmwareMain      from "../Firmware/FirmwareMain";
import FirmwareForm      from "../Firmware/FirmwareForm";
import Dr from "../Dr/Dr";
import DashboardMain     from "../Dashboard/DashboardMain";
import TestToolPage from "../test-tool-page";
import { ROUTES } from "../../commons/constants/routes/routes";

class DefaultApp extends Component {
  render() {
    const HeaderWithRouter = withRouter(Header);
    const ProjectTitleWithRouter = withRouter(ProjectTitle);

    return (
      <Router>
        <HeaderWithRouter />
        {/* 2024.08.16 - 포맷 바꾸지 말것!!! : 너무 길어지면 한눈에 파악이 어렵습니다. - */}
        <main id="main" style={{ flex: "1" }}>
          <Switch>
            <Route path={ROUTES.DIAGRAM} exact component={Diagram} />
            <Route path={ROUTES.SAMPLE} exact component={Sample} />
            <Route path={ROUTES.ROOT} exact component={Login} />
            <Route path={ROUTES.LOGIN} component={Login} />
            <Route path={ROUTES.SIGNUP} component={Signup} />
            <Route path={ROUTES.FIND_ACCOUNT} component={FindAccount} />
            <Route path={ROUTES.FLOW} exact component={Flow} />

            <AuthenticatedRoute path={ROUTES.MAIN()} component={Main} />
            <AuthenticatedRoute path={ROUTES.LOGOUT} component={Logout} />
            <AuthenticatedRoute path={ROUTES.TEST_TOOL} component={TestToolPage} />

            <AuthenticatedRoute path={ROUTES.HOME_MAIN} component={NewMain} />
            <AuthenticatedRoute path={ROUTES.DASHBOARD.MAIN} component={DashboardMain} />

            <AuthenticatedRoute path={ROUTES.PROJECT.MAIN} component={ProjectMain} />
            <AuthenticatedRoute path={ROUTES.PROJECT.CREATE} component={ProjectCreate} />
            <AuthenticatedRoute path={ROUTES.PROJECT.MAP} component={ProjectMap} />
            <AuthenticatedRoute path={ROUTES.PROJECT.EDIT()} component={ProjectEdit} />
            <AuthenticatedRoute path={ROUTES.DR} component={Dr} />

            <AuthenticatedRoute path={ROUTES.SITE_MANAGER.MAIN}   component={SiteManagerMain} />
            <AuthenticatedRoute path={ROUTES.SITE_MANAGER.CREATE} component={SiteManagerCreate} />
            <AuthenticatedRoute path={ROUTES.SITE_MANAGER.EDIT()} component={SiteManagerEdit} />

            <AuthenticatedRoute path={ROUTES.MEMBER.MAIN}   component={MemberMain} />
            <AuthenticatedRoute path={ROUTES.MEMBER.CREATE} component={MemberCreate} />
            <AuthenticatedRoute path={ROUTES.MEMBER.EDIT()} component={MemberEdit} />

            <AuthenticatedRoute path={ROUTES.CS_INQUIRY.DETAIL()} component={InquiryDetail} />
            <AuthenticatedRoute path={ROUTES.CS_INQUIRY.MAIN}     component={InquiryMain} />
            <AuthenticatedRoute path={ROUTES.NOTICE.CREATE}        component={NoticeCreate} />
            <AuthenticatedRoute path={ROUTES.NOTICE.EDIT()}        component={NoticeCreate} />
            <AuthenticatedRoute path={ROUTES.NOTICE.DETAIL()}      component={NoticeDetail} />
            <AuthenticatedRoute path={ROUTES.NOTICE.MAIN}          component={NoticeMain} />

            <Route path={ROUTES.PLANT_LIST().BASE} render={() => (
              <>
                <ProjectTitleWithRouter />
                <Switch>
                  <AuthenticatedRoute path={ROUTES.PLANT_LIST().MAIN} component={PlantListMain} />
                  <AuthenticatedRoute path={ROUTES.PLANT_LIST().CREATE} component={PlantListCreate} />
                  <AuthenticatedRoute path={ROUTES.PLANT_LIST().DETAIL()} component={PlantListDetail} root="plant" />
                  <AuthenticatedRoute path={ROUTES.PLANT_LIST().DRAWING()} component={PlantListDrawing} root="plant" />
                  <AuthenticatedRoute path={ROUTES.PLANT_LIST().DRAWING_V2()} component={PlantListDrawingV2} root="plant" />
                  <AuthenticatedRoute path={ROUTES.PLANT_LIST().UPDATE()} component={PlantListUpdate} root="plant" />
                  <AuthenticatedRoute path={ROUTES.PLANT_LIST().EQUIP()} component={PlantEquip} root="plant" />
                  <AuthenticatedRoute path={ROUTES.PLANT_LIST().SOLAR_CREATE} component={SolarPanelCreate} />
                  <AuthenticatedRoute path={ROUTES.PLANT_LIST().SOLAR_DETAIL()} component={SolarPanelDetail} />
                  <AuthenticatedRoute path={ROUTES.PLANT_LIST().SOLAR_EDIT()} component={SolarPanelEdit} />
                  <AuthenticatedRoute path={ROUTES.PLANT_LIST().POWER_CREATE} component={PowerDeviceCreate} />
                  <AuthenticatedRoute path={ROUTES.PLANT_LIST().POWER_DETAIL()} component={PowerDeviceDetail} />
                  <AuthenticatedRoute path={ROUTES.PLANT_LIST().POWER_DETAIL_CARRIER} component={PowerCarrierDetail} />
                  <AuthenticatedRoute path={ROUTES.PLANT_LIST().POWER_EDIT()} component={PowerDeviceEdit} />
                  <AuthenticatedRoute path={ROUTES.PLANT_LIST().BATTERY_CREATE} component={BatteryCreate} />
                  <AuthenticatedRoute path={ROUTES.PLANT_LIST().BATTERY_EDIT()} component={BatteryEdit} />
                  <AuthenticatedRoute path={ROUTES.PLANT_LIST().BATTERY_DETAIL()} component={BatteryDetail} />
                  <AuthenticatedRoute path={ROUTES.PLANT_LIST().BATTERY_GRAPH()} component={BatteryGraph} />
                </Switch>
              </>
            )} />

            <Route path={ROUTES.PLANT_STATUS().BASE} render={() => (
              <>
                <ProjectTitleWithRouter />
                <Switch>
                  <AuthenticatedRoute path={ROUTES.PLANT_STATUS().ISSUE_DETAIL()} component={PlantStatusIssueDetailV2} root="plant" />
                  <AuthenticatedRoute path={ROUTES.PLANT_STATUS().ISSUE_DETAIL_OV()} component={PlantStatusIssueDetail} />
                  <AuthenticatedRoute path={ROUTES.PLANT_STATUS().INVERTER()} component={PlantDetailInverter} />
                  <AuthenticatedRoute path={ROUTES.PLANT_STATUS().INVERTER_STAT()} component={PlantDetailInverterStat} />
                  <AuthenticatedRoute path={ROUTES.PLANT_STATUS().ISSUE_COMBINER()} component={PlantStatusCombiner} />
                  <AuthenticatedRoute path={ROUTES.PLANT_STATUS().ISSUE_HISTORY} component={PlantStausIssueHistory} />
                  <AuthenticatedRoute path={ROUTES.PLANT_STATUS().ISSUE_HISTORY_DETAIL()} component={PlantStausIssueHistoryDetail} />
                </Switch>
              </>
            )} />

            <AuthenticatedRoute path={ROUTES.EMS} component={EmsMain} />
            <Route path={ROUTES.EMS_NEW()} render={() => (
              <>
                <ProjectTitleWithRouter />
                <Switch>
                  <AuthenticatedRoute path={ROUTES.EMS_NEW()} component={EmsMainNew} />
                </Switch>
              </>
            )} />

            <AuthenticatedRoute path={ROUTES.MYPAGE} component={Mypage} />
            <AuthenticatedRoute path={ROUTES.FIRMWARE.CREATE} component={FirmwareForm} />
            <AuthenticatedRoute path={ROUTES.FIRMWARE.EDIT()} component={FirmwareForm} />
            <AuthenticatedRoute path={ROUTES.FIRMWARE.MAIN} component={FirmwareMain} />
            <AuthenticatedRoute path={ROUTES.INQUIRY} component={Inquiry} />
          </Switch>
        </main>
        <Footer />
      </Router>
    );
  }
}

export default DefaultApp;
